// @flow
import * as React from 'react';

import AdminAddAdminContainer from './AdminAddAdminContainer';
import AdminAddAdminForm from './AdminAddAdminForm';

type Props = {
  organizations: Array<*>,
  districtId: ?Backbone$Id,
  onRequestHide: () => void,
};

class AdminAddAdmin extends React.Component<Props, *> {
  render() {
    return (
      <AdminAddAdminContainer>
        {props => (
          <AdminAddAdminForm
            {...props}
            organizations={this.props.organizations}
            onRequestHide={this.props.onRequestHide}
            districtId={this.props.districtId}
          />
        )}
      </AdminAddAdminContainer>
    );
  }
}

export default AdminAddAdmin;
